import { useNavigate } from 'react-router-dom';
import type { CarStatus } from '@fleet/shared';
import { euro } from '@fleet/shared';
import { Badge, Button } from '../../design-system';
import { Eyebrow } from '../../components/ui/Eyebrow';
import { useArchivedCars } from '../fleet/fleet.api';

const COLS = '100px 120px 175px 95px 120px 1fr 110px';

const STATUS_LABEL: Record<string, string> = {
  VERKOCHT: 'Verkocht',
  TOTAL_LOSS: 'Total loss',
  INGELEVERD: 'Ingeleverd',
};

function label(status: CarStatus): string {
  return STATUS_LABEL[status] ?? status;
}

export function ArchivePage() {
  const navigate = useNavigate();
  const { data, isLoading } = useArchivedCars();
  const cars = data ?? [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div>
        <Button variant="ghost" size="sm" onClick={() => navigate('/wagenpark')}>
          ← Wagenpark
        </Button>
        <Eyebrow>Archief</Eyebrow>
        <h2 style={{ margin: '4px 0 0', fontSize: 22, fontWeight: 900, color: '#111111' }}>
          Verkocht, total loss &amp; ingeleverd.
        </h2>
        <p style={{ margin: '6px 0 0', fontSize: 14, color: '#666666' }}>
          Deze auto's tellen niet mee in de dashboardtotalen.
        </p>
      </div>

      <div style={{ background: '#FFFFFF', border: '1px solid #E3D9CC', borderRadius: 4 }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: COLS,
            gap: 10,
            padding: '12px 20px',
            borderBottom: '2px solid #111111',
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: '#666666',
          }}
        >
          <span>Kenteken</span>
          <span>Status</span>
          <span>Merk / model</span>
          <span>Brandstof</span>
          <span>Cat.waarde</span>
          <span>Reden / notitie</span>
          <span>Kosten</span>
        </div>
        {isLoading && <div style={{ padding: '24px 20px', color: '#888888' }}>Archief laden…</div>}
        {cars.map((c) => (
          <div
            key={c.kenteken}
            onClick={() => navigate(`/auto/${encodeURIComponent(c.kenteken)}`)}
            style={{
              display: 'grid',
              gridTemplateColumns: COLS,
              gap: 10,
              padding: '12px 20px',
              borderBottom: '1px solid #F0E8DC',
              fontSize: 13,
              alignItems: 'center',
              color: '#666666',
              cursor: 'pointer',
            }}
          >
            <span
              style={{ fontWeight: 700, fontFamily: "'Roboto Mono', monospace", color: '#111111' }}
            >
              {c.kenteken}
            </span>
            <Badge tone="neutral">{label(c.status)}</Badge>
            <span>
              {c.merk} {c.model}
            </span>
            <span>{c.brandstof}</span>
            <span>{c.catalogusprijs ? euro(c.catalogusprijs) : '—'}</span>
            <span>{c.archiefNotitie || '—'}</span>
            <span style={{ fontWeight: 700, color: '#111111' }}>
              {c.kostenTotaal ? euro(c.kostenTotaal) : '—'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
